<template>
  <div class="has-text-left roundedCorners" style="height: 100%">
    <div id="loader-container" v-if="!response && validUrl" :style="{width: cardWidth}">
      <slot name="loading">
        <div class="spinner"></div>
      </slot>
    </div>
    <div v-if="response"  style="height: 100%" class="posRelative">
      <img-chooser v-if="response.images.length > 1 && imgSelected == false" :images="response.images"></img-chooser>
      <div v-if="!$parent.myCard" class="notMineEditWindow">
          <div>{{$parent.initials}}</div>
      </div>
    
      <slot :img="response.images[0]" :title="response.title" :description="response.description" :url="url" :site="response.site">

        <div v-if="showScreenshotOffer && $root.app.inApp && !showPaster && !imgChoice && img == defImg" class="screenshotOffer">
          <button id="ssButt" class="button is-coolGreen" :class="{'is-loading' : loadingSS}"  @click="takeScreenshot">Get site screenshot</button>
        </div>
      	
        <div id="imgWrapper" class="wrapper" :style="{'max-width':cardWidth}" style="min-width: 375px">
           
            <img v-if="overlay && !imgChoice" class="miimuDefOverlay" :src="overlayImg"/>
          	<drop v-if="!cropper" class="has-text-centered editCardImgBG posRelative"  @drop="dropOnCropper">
             
              <div class="has-text-left"><span class="has-text-white fa fa-camera editCardCameraIcon handCursor fa-2x" @click="openImgChoice"></span></div>
              <input type="file" style="display: none" @change="fileChanged"  ref="fileInput"/>
              
              <div id="imgChoiceDiv" v-show="imgChoice" class="has-background-dark" >
                <div class=" delete" style="position: absolute; right: 5px; top: 5px" @click="imgChoice = false"></div>
                
                <div v-if="showPaster" class="paster">
                  
                  <div class="innerPaster" contenteditable="true" @paste="pasterChanged($event)" @keydown="keyDown($event)" @keyup="keyUp" ref="paster"></div>
                  <div class="pasterPlaceholder">
                    <span class="top40 is-inline-block">Paste Here</span><br>
                    <i class="fa fa-paste fa-4x top30"></i>
                  </div>
                  
                </div>

                <div style="border: 1px dashed #ccc; display: inline-block; padding: 0 30px 0 30px; border-radius: 10px; ">
                  <div v-if="!$root.app.inApp" class="has-text-centerd imgGetChoice top10 handCursor" >
                    <i class="fa fa-crop fa-2x"></i><br>
                    <div class="">Drop an image file here</div>
                  </div>
                  <div id="pendingPasteSpinner" v-if="$root.app.inApp" class="has-text-centerd imgGetChoice top10 handCursor" @click="takeScreenshot" >
                    <i class="fa fa-crop fa-2x"></i><br>
                    <div class="">Take website screenshot</div>
                  </div>
                   <div class="is-size-7"><b>OR</b></div>
                  <div class="has-text-centerd imgGetChoice top5 handCursor" @click="fileChooser">
                    <i class="fa fa-image fa-2x"></i><br>
                    <div class="" >Choose from your images</div>
                  </div>
                  <div class="is-size-7"><b>OR</b></div>
                  <div class="imgGetChoice has-text-centerd top5 bottom10 handCursor" @click="clipboard">
                    <i class="fa fa-paste fa-2x"></i><br>
                    <div class="top5" >Use image in clipboard</div>
                  </div>
                </div>
                <div v-show="notAnImage" class="has-text-danger">Clipboard does not contain an image</div>
                

              </div>
              <img style="width: 100%" :src="img"  @error="imgError">
              
            </drop>

            <div style="height: 222px" v-show="cropper" >
              <clipper-basic class="myClipper" :bgColor="'black'" ref="clipper" :ratio="180/100"  :wrapRatio="180/100" :initWidth="95"  :src="img"></clipper-basic>
            </div>

            <div v-if="cropper" class="has-text-centered has-background-light">
              <button class="button is-coolGreen is-small" @click="cropperClip">Preview</button>&nbsp;
              <button class="button is-small" @click="cancelCropper">Cancel</button>
            </div>

        		<div class="card-info">
            <div v-if="noUsable" class="has-background-dark">
              <div>&nbsp;No usable images found</div>
            </div>

             

          		<div class="card-text posRelative editCardInfoContainer">
                <!--  <button v-if="!callApi" class="commentsButton button tiny is-coolGreen" @click="$parent.openComments()">Comments</button> -->
                <div class="has-text-light top5 is-size-7" style="position: relative; top: 2px; left: 5px;"><b>TITLE</b></div>
            		<div class="editCardTitleDetails is-size-65  top5 contentEditable" contenteditable="true" ref="title" v-text="response.title" @focus="titleFocus" @blur="titleBlur"></div>
                <div v-show="titleEmpty" class="is-size-7 has-text-danger">Please enter a title</div>
                <div class="has-text-light top5 is-size-7" style="position: relative; top: 2px; left: 5px;"><b>DESCRIPTION</b></div>
            		<div class="editCardDesc is-size-65 top5 contentEditable" contenteditable="true" ref="description" v-text="response.description" @focus="descFocus" @blur="descBlur"></div>

                 <div class="top5"> &nbsp;<i>{{response.site}}</i></div> 
             
          		</div>
          	
        		</div>
      	</div>
    	</slot>
  	</div>
  </div>
</template>

<script>


import { Drag, Drop } from 'vue-drag-drop'
import ImgChooser from './ImgChooser'
import defImages from '../static/defimages'
import { AZEventBus } from './AZEventBus'
const axios = require('axios')



export default {
  components: {Drop, ImgChooser},
  name: 'link-prevue',
  props: {
    url: {
      type: String,
      default: ''
    },
    cardWidth: {
      type: String,
      default: '380px'
    },
    onButtonClick: {
      type: Function,
      default: undefined
    },
    showButton: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default:  'https://infinite-bayou-72524.herokuapp.com/' //'https://linkpreview-api.herokuapp.com/'
    },
    cardsIndex: {
      type: Number,
      default: null
    },
    callApi: {
      type: Boolean,
      default: true
    },
    cardPack: {
      type: Object,
      default: undefined
    }
  },
  watch: {
    url: function(value) {
      
      if(this.callApi){
        this.response = null
        this.getLinkPreview(true)

      }
    }
  },
  mounted() {

    var self = this;

    if(this.callApi){
      this.getLinkPreview(true)
    } else {
      this.loadCard()
    } 

    AZEventBus.$on('readyForPaste', this.readyForPasteHandler);

  },
  data: function() {
    return {
      response: null,
      validUrl: false,
      card: null,
      cropper: false,
      resultURL: '',
      img: '',
      currImg: '',
      imgChanged: false,
      imgSelected: false,
      imgChoice: false,
      newImgFromSite: false,
      noUsable: false,
      overlay: false,
      notAnImage: false,
      showPaster: false,
      pasterFlag: false,
      pendingPaste: false,
      showScreenshotOffer: false,
      loadingSS: false,
      dumber: 'A',
      isInsta: false,
      titleEmpty: false
    }
  },

  beforeDestroy: function(){
    AZEventBus.$off('readyForPaste', this.readyForPasteHandler);
  },

  methods: {

    readyForPasteHandler: function(msg){
      if(this.$root.app.inApp){
        if(this.pendingPaste){
          this.pendingPaste = false
          this.showPaster = true
          this.imgChoice = true
          this.loadingSS = false
          az.addRemSpinner(false, 'id', 'pendingPasteSpinner')
        } 
      }
    },

    isValidUrl: function(url) {
      const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,20}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
      this.validUrl = regex.test(url)
      return this.validUrl
    },
    getLinkPreview: async function(limitToOgImage) {

     

      var self = this;

      var limitImage = limitToOgImage ? "y" : "n"

      var url = this.callApi ? this.url : this.card.url
  

     /*  if(url.split('//youtu.be/').length > 1){
        let ytId = url.split('//youtu.be/')[1]
        url = '33https://www.youtube.com/watch?v=' + ytId    
      } */

      if(url.split('33//pin.it/').length > 1){
        url =  url.split(' Look at this')[0]
        this.url = url
        this.$parent.url = url
        this.$parent.dispUrl = url
      }

      if(url.split('33https://soundcloud.com/').length > 1){
        url = 'https://soundcloud.com/' + url.split('https://soundcloud.com/')[1].split(' ')[0]
        this.url = url
        this.$parent.url = url
        this.$parent.dispUrl = url
      }
     
      if (this.isValidUrl(url)) {
       
        if(this.imgChoice)
          az.addRemSpinner(true, "id", "imgChoiceDiv")

        let t = url.split('://')
        var site = t[1].split('/')[0]

        self.overlay = az.overlaySorter(site, this.url, false)

        

        if(site.toLowerCase() == '33www.amazon.com' && url.split('33amazon.com/gp/').length == 1){

            function wa(d){
              var temp4 = {}

              temp4.site = site;
              temp4.url = url;
              temp4.title = d.title
              temp4.description= d.description
              temp4.images = [d.img]
              
              self.response = temp4;
              self.img = d.img || self.defImg
              self.currImg = d.img;

              
            }

            function na(){
              
            }

            let ama = await this.$root.app.apiClient.post('auth/account/scrapeamazon', {url: url}, wa, na)

      

        } else if(site.toLowerCase() == '33twitter.com'){

            function w(d){
              d = d.d
              var temp3 = {}
              var ttImg

              if(ep == 'post'){
                ttImg = d.includes.users[0].profile_image_url

                temp3.site = site;
                temp3.url = url;
                temp3.title = d.includes.users[0].name + ' - TT'
                temp3.description= d.data[0].text
                temp3.images = [ttImg]
                
                self.response = temp3;
                self.img = ttImg|| this.defImg
                self.currImg = ttImg;
              } else {
                ttImg = d.data[0].profile_image_url

                temp3.site = site;
                temp3.url = url;
                temp3.title = d.data[0].name + ' - @' + d.data[0].username
                temp3.description= d.data[0].description
                temp3.images = [ttImg]
                
                self.response = temp3;
                self.img = ttImg|| this.defImg
                self.currImg = ttImg;

              }
            }

            function n(){

            }
            var tid
            var ep
            if(url.split('/status/').length == 2){
               tid = url.split('/status/')[1]
               ep = 'post'
            } else {
              tid = url.split('twitter.com/')[1];
              ep = 'profile'
            }

            this.$root.app.apiClient.get('auth/account/t/' + tid + '/' + ep, {}, w, n)




        } else {
          
                this.httpRequest((response) => {
                 
                 
                  
                  let temp = JSON.parse(response)
                 

                  if(temp.error){

                   

                    let t = this.url.split('://')
                  
                    let obj = {
                      url: this.url,
                      title: 'Enter title',
                      description: 'Enter description',
                      images: [],
                      site: t[1].split('/')[0]
                    }

                    this.currImg = this.defImg;
                    this.img = this.defImg;

                  

                    this.response = obj
                   

                    return
                    /* if(self.$root.app.inApp){
                      self.loadingSS = true
                      window.webkit.messageHandlers.myMessageName.postMessage("url||" + self.url)
                    } */
                  } else {
                    var tempArr = [temp.image]
                    temp.images = tempArr
                  }
                  
                  
                  
                  //process and manipulate response here
                  //Extract Site
                  //temp.url = url
                  temp.site = site

                  if(temp.images[0]){


                    if(temp.images[0].substring(0, 4) != 'http'){
                      temp.images[0] = "http://" + temp.site + temp.images[0]
                    }
               

                    let filtered = temp.images.filter(e => {
                      return e.split('.jpg').length ==  2 || e.split('.jpeg').length == 2 || e.split('.svg').length == 2 || e.split('.png').length == 2 || e.split('.gif').length == 2 
                      || e.split('i.scdn.co/image').length == 2 || e.split('mosaic.scdn.co').length == 2 //spotify
                      || e.split('mzstatic.com/image/').length == 2 //iTunes
                      || e.split('images.wsj.net').length == 2 //Wall street journal
                      || e.split('i.insider.com').length == 2 //Business Insider
                      
                    })

                    //temp.images[0] = filtered[0] || ''
                  
                    //temp.images = filtered
           

                   if(site == 'instagram.com' || site == 'www.instagram.com'){  

                      
                        function w(d){
                          az.addRemSpinner(false, 'id', 'imgWrapper')
                         
                          var temp2 = d.split('/9j/4 ').join('')
                          self.img = 'data:image/png;base64,' + temp2;

                          self.cropper = true; 

                          self.isInsta = true
                                    
                        }

                        function n(){
                          az.addRemSpinner(false, 'id', 'imgWrapper')
                        }

                        az.addRemSpinner(true, 'id', 'imgWrapper')
                        this.$root.app.apiClient.get('subs/data/imgprox?q=' + encodeURIComponent(temp.images[0]), {}, w, n)


                    } 
                    

                  
                  }

               


                  if(!this.imgChoice){
                    self.response = temp;
                    if(!self.isInsta){
                      self.img = this.response.images[0] || this.defImg
                      self.currImg = this.img;
                    } else {
                      self.isInsta = false
                    }
                  
                  } else {
                    this.response.images = temp.images
                    this.imgChoice = false
                    this.imgSelected = false
                    this.newImgFromSite = true;
                    if(temp.images.length < 2){
                      this.noUsable = true
                    } else {
                      this.currImg = this.response.images[0] || this.defImg
                    }
                    
                                
                    az.addRemSpinner(false, "id", "imgChoiceDiv")
                  }

             
                  

                }, () => {
                

                  let t = this.url.split('://')
                  
                  let obj = {
                    url: this.url,
                    title: 'Enter title',
                    description: 'Enter description',
                    images: [],
                    site: t[1].split('/')[0]
                  }

                  this.currImg = this.defImg;
                  this.img = this.defImg;

                

                  this.response = obj

                  if(self.$root.app.inApp){
                    window.webkit.messageHandlers.myMessageName.postMessage("url||" + self.url)
                  }

                  

                  //this.response = null
                  //this.validUrl = false
                
                  
                },
                url,
                limitImage
                )
        }

       
      
      } else {
        //this.$parent.removeSaveListener()
        self.$root.app.showModalOK({message: 'The URL provided is not valid.'})
      }
    },


    titleFocus: function(){
      if(this.response.title == 'Enter title')
        this.response.title = ''
    },

    titleBlur: function(){
      var self = this;
      self.$nextTick(() => {
        if(self.$refs.title.textContent == ''){
          self.response.title = 'Enter title';
          self.titleEmpty = true
        }
      })
    
    },

    descFocus: function(){
      if(this.response.description == 'Enter description')
        this.response.description = ''
    },

    descBlur: function(){
      var self = this;
      self.$nextTick(() => {
        if(self.$refs.description.textContent == ''){
          self.response.description = 'Enter description'
        }
      })
    },



    loadCard: function(){

      if(this.cardPack == undefined){
        this.card = this.$root.app.cards[this.cardsIndex];

        for(let i=0; i< this.card.parents.length; i++){
          this.$parent.existingBundlesForEdit.push(this.card.parents[i].id)
        }
        
      } else {
        this.card = this.cardPack
        this.url = this.cardPack.url
      }

      this.$parent.note = this.card.note
      this.$parent.privNote = this.card.privNote
      this.$parent.selectedTags = this.card.tags
      this.$parent.dispUrl = this.card.url
      this.$parent.site = this.card.site

      this.$parent.shareId = this.card.shareId
      this.$parent.imported = true
      this.$parent.origId = this.card.id
      this.$parent.standAloneImport = true
      
      var temp = {}
      temp.images = [this.card.img];
      temp.title = this.card.title;
      temp.description = this.card.description;
      temp.site = this.card.site;
      temp.url = this.card.url;

      this.response = temp;
      this.img = this.response.images[0] || this.defImg;
      this.currImg = this.img;

      this.overlay = az.overlaySorter(this.response.site, this.response.url, this.img)
    },
    
    httpRequest: function(success, error, url, limitToOgImage) {


      const http = new XMLHttpRequest()
      const params = 'key=' + 'c5bd3dcac0da15edc8f15867fd4ae02f' + "&q=" + url
      http.open('POST', 'https://api.linkpreview.net', true)
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      http.onreadystatechange = function() {
        
    		if (http.readyState === 4 && (http.status === 200 || http.status === 425)) {
            
        	   success(http.responseText)
    		}
        if (http.readyState === 4 && http.status === 500 || http.status === 423) {
        	   error()
           }
        if (http.readyState === 4 && http.status === 400) {
        	   error()
    		}
      }
      http.send(params)

     

      
      /* const http = new XMLHttpRequest()
      const params = 'url=' + url + "&limitToOgImage=" + limitToOgImage
      http.open('POST', this.apiUrl, true)
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      http.onreadystatechange = function() {
    		if (http.readyState === 4 && http.status === 200) {
        	   success(http.responseText)
    		   }
        if (http.readyState === 4 && http.status === 500) {
        	   error()
           }
        if (http.readyState === 4 && http.status === 400) {
        	   error()
    		}
      }
      http.send(params) */
    },


    httpRequestAZScraper: function(success, error) {
        
        function w(d){
          let temp = d.r
         
          if(temp.ogImage == undefined)
            temp.ogImage = []

          if(temp.ogImage.hasOwnProperty('width')){
            temp.ogImage = [temp.ogImage.url]
          } else if(temp.ogImage[0]) {
            
          }

          let obj = {
            title: temp.ogTitle ? temp.ogTitle : '',
            description: temp.ogDescription ? temp.ogDescription : '',
            images: temp.ogImage
          }
          success(JSON.stringify(obj))
        }

        function n(){
          error()
        }
        this.$root.app.apiClient.post('auth/account/scrape', {url: this.url}, w, n)
    },

    useSS: function(){
      this.showPaster = true
      this.imgChoice = true
    },



  


    toggleCropper: function(){
       this.cropper = !this.cropper;
    },
    cropperClip: function(){
      const canvas = this.$refs.clipper.clip();//call component's clip method
      this.resultURL = canvas.toDataURL("image/jpeg", 0.3);//canvas->image
      
      this.img = this.resultURL
      this.currImg = this.img;
      this.imgChanged = true;
      this.cropper = false    
      this.imgChoice = false
    },

    dropOnCropper: function(data, e){

      var self = this;

      this.imgChoice = false;

      this.noUsable = false

      e = e || window.event; // get window.event if e argument missing (in IE)
      if (e.preventDefault) {
          e.preventDefault();
      } // stops the browser from redirecting off to the image.



      var dt = e.dataTransfer;
      var files = dt.files;

      var fileReader = new FileReader();


      var file = files[0];

      if (/^image\/\w+$/.test(file.type)) {
          fileReader.readAsDataURL(file);
          fileReader.onload = function () {
              self.img = this.result;
              self.cropper = true;    
          };


      } else {
          showMessage("Please use an image file.");
      }


      return false;
    },

    /* openFileChooser: function(){
        <div class="field">
            Driver's License Image:*
            <input type="file"
                id="dl" name="dl"
                accept="image/png, image/jpeg" />
        </div>
    }, */

    loadCardPack: function(){
      //alert('cardPack')
    },

    cancelCropper: function(e){
      this.img = this.currImg
      this.cropper = false
    },
    imgError: function(){
      if(!this.isInsta)
        this.img = this.defImg
      //if(this.$root.app.inApp){
        this.showScreenshotOffer = true
      //}
    },
    fileChooser: function(){
      this.noUsable = false
      this.imgChoice = false
      this.imgSelected = true
      this.$refs.fileInput.click()
    },
    fileChanged: function(e){
      // getting a hold of the file reference

      var self = this;
      var file = e.target.files[0]; 

      
      // setting up the reader
      var reader = new FileReader();
      reader.readAsDataURL(file); // this is reading as data url

      // here we tell the reader what to do when it's done reading...
      reader.onload = readerEvent => {
        var content = readerEvent.target.result; // this is the content!
        if (/^image\/\w+$/.test(file.type)) {
          reader.readAsDataURL(file);
          reader.onload = function () {
              self.img = content;
              self.cropper = true;    
          };


      } else {
          this.$root.app.showModalOK({message: 'Please select an image file.'});
      }
        
          
      }
    },

    openImgChoice: function(){
      this.showPaster = false
      this.imgChoice =  !this.imgChoice
    },

    reScrape: function(){
      this.getLinkPreview(false)
    },

    pasterChanged: function(e){
      //e.preventDefault()
      var self = this;
      setTimeout(function(){
        self.img = self.$refs.paster.firstChild.src
        self.$refs.paster.textContent = ""
        self.cropper = true;  
        self.showPaster = false
      }, 5)
      
     /*  self.img = this.$refs.paster.firstChild.attributes.src;
       */

    },

    keyUp: function(e){
      if(e.key == 'Meta' || e.key == 'Ctrl'){
        this.pasterFlag = false
      }
      
    },

    keyDown: function(e){
      if(e.key == 'Meta' || e.key == 'Ctrl'){
        this.pasterFlag = true
      }
      if(this.pasterFlag && (e.key == 'v')){
        
      } else {
        e.preventDefault()
        e.stopPropagation()
      }
    },
  

    clipboard: async function(){
      var self = this;
      this.notAnImage = false
      this.showPaster = true
      this.loadingSS = false
  
      

      return false;
    },

    selectImg: function(img){
      this.img = img
      this.imgSelected = true
    },

    takeScreenshot: function(){
        window.webkit.messageHandlers.myMessageName.postMessage("url||" + this.$parent.dispUrl)
        this.notAnImage = false
        az.addRemSpinner(true, 'id', 'pendingPasteSpinner')
        this.pendingPaste = true
        this.loadingSS = true
    }

  },
  computed:{


    defImg: function(){

     /*  if(this.overlay){
        //return defImages.bgs[az.getRandomInt(10)].img
        return defImages.bgs[10].img
      } */
      return `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`

    },
    overlayImg: function(){
      return defImages.overlays[this.overlay]
    },
    defImgPdf: function(){
      return '@/assets/img/miiMuDefaultPDF.jpg';
    }
  },

/*   watch: {
    img: function(){
      if(this.defImg == this.img){
        this.showScreenshotOffer = true
      }
    }
  } */
}
</script>

<style scoped>
/*@import url('https://fonts.googleapis.com/css?family=Hind+Siliguri:400,600');*/

.wrapper {
  overflow: auto;
  background-color: #fff;
  -webkit-box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  min-height: 400px;
  padding-bottom: 20px;
  height: 100%
}

.card-img {
  width: 100%
}

.card-img img {
  width: 100%;
  border-radius: 7px 7px 0 0;
}

img {
  vertical-align: middle;
  border-style: none;
}

.card-info {
  border-radius: 0 0 7px 7px;
  background-color: #ffffff;
}

.card-text {
  width: 95%;
  margin: 0 auto;

}

.card-text h1 {
  font-size: 24px;
  color: #474747;
  margin: 5px 0 5px 0;
  font-family: 'Hind Siliguri', sans-serif;
}


.card-btn {
  margin: 1em 0 1em 0;
  position: relative;
  text-align: center;
}

/* Loader */
.spinner {
  margin-top: 40%;
  margin-left: 45%;
  height: 28px;
  width: 28px;
  animation: rotate 0.8s infinite linear;
  border: 2px solid #ccc;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotate {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}
</style>